export default {
  "header": {
    "title": "Digital checklist list"
  },
  "card": {
    "list": {
      "title": "Lists",
      "create": "Create lists",
      "name": "Name",
      "click": "Click to add an item",
      "delete": "Delete",
      "action": "Actions",
      "label_alert": "The name on the least must at least contain one letter",
      "legend_text": "There are no created lists",
      "placeholder": "Add a list ...",
      "label": "Add a new list by pressing Enter or cancel by pressing Esc"
    },
    "item": {
      "title": "List items",
      "tooltip_err_mes": "You must select a list to add an item",
      "create": "Add item",
      "delete": "Delete",
      "edit": "Edit",
      "new_items": "-new created items",
      "edited_items": "-edited items",
      "delete_items": "-deleted items",
      "name": "Name",
      "action": "Actions",
      "legend_text": "There are no created items",
      "label": "Add a new item by pressing Enter or cancel it by pressing Esc.",
      "label_alert": "The name of the item must at least contain a letter or a number",
      "placeholder": "Add an item to the list",
      "btn_cancel": "Cancel",
      "btn_save": "Save"
    },
    "input": {
      "addItemLabel": "add new item",
      "labelAlert": "The name of the list must at least contain one letter or a number"
    },
    "toastrLable": {
      "success": "List was successfully created",
      "info": "Information",
      "error": "The list was not created",
      "deletError": "The list was not deleted",
      "itemDeleteSuccess": "The item was successfully deleted",
      "listDeleteSuccess": "The list was successfully deleted",
      "itemEditSuccess": "The item has been successfully been edited",
      "confirm": "Yes",
      "cancel": "No",
      "question": "Are you sure you want to delete",
      "list": "the list",
      "item": "the item",
      "err": "Error",
      "caution": "Delete a list that is being used by a digital checklist",
      "caution1": "might cause unexpected behaviors.",
      "deleteItem": "Delete this item",
      "editItem": "Edit item",
      "change": "Information was successfully saved",
      "notChange": "The changes were not saved",
      "save": "Are you sure you want to save the following changes made on this list",
      "_cancel": "Are you sure you want to cancel the changes made on this list"
    }
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/dynamic_list.js